import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    background: `linear-gradient(60deg, transparent calc(22vw + 30px),${theme.palette.primary.main} 22vw)`,
  },
  flexGrow: {
    flexGrow: 1,
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit',
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900],
    },
  },
  trialIcon: {
    marginRight: theme.spacing(1),
  },
  notificationsButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  messagesButton: {
    marginLeft: theme.spacing(2),
  },
  messagesBadge: {
    backgroundColor: colors.green[600],
  },

  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  topNavUserInfo: {
    paddingTop: 10,
    paddingBottom: 10,
    color: '#ffffff',
  },
  subheader: {
    color: '#ffffff',
  },
  title: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: 500,
  },
  loginText: {
    color: 'white',
    fontSize: '1.25vw',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '16px',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  fontSizeIcons: {
    cursor: "pointer"
  }
}));
